import { HERO_NAMED_CLIENTS, LIVE_PRODUCT_COUNT } from '@/lib/client-roster';
import { ClientEmblem } from '@/components/emblems/ClientEmblem';

export function HeroTrustStrip() {
  return (
    <div
      data-hero-trust-strip
      className="mt-6 flex flex-col items-center gap-2 px-4"
      style={{
        animation: 'fade-up 0.8s cubic-bezier(0.16, 1, 0.3, 1) 1.3s both',
      }}
    >
      <span
        className="font-mono"
        style={{
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          color: 'var(--hero-text-muted, #c8b89a)',
        }}
      >
        {LIVE_PRODUCT_COUNT} products live, in daily use by
      </span>
      <div
        className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5"
        style={{ maxWidth: 720 }}
      >
        {HERO_NAMED_CLIENTS.map((entry, i) => {
          const inner = (
            <span className="inline-flex items-center gap-1.5">
              {entry.emblem && <ClientEmblem id={entry.emblem} size={14} />}
              <span style={{ fontSize: 13, fontWeight: 600, letterSpacing: '-0.01em' }}>
                {entry.name}
              </span>
            </span>
          );
          const labelled = entry.url ? (
            <a
              key={entry.name}
              href={entry.url}
              target="_blank"
              rel="noopener noreferrer"
              className="font-sans transition-colors duration-200"
              style={{ color: 'var(--hero-text-secondary, #f5edd9)' }}
            >
              {inner}
            </a>
          ) : (
            <span key={entry.name} className="font-sans" style={{ color: 'var(--hero-text-secondary, #f5edd9)' }}>
              {inner}
            </span>
          );
          return (
            <span key={entry.name} className="inline-flex items-center gap-x-5">
              {labelled}
              {i < HERO_NAMED_CLIENTS.length - 1 && (
                <span
                  aria-hidden="true"
                  className="font-mono"
                  style={{ fontSize: 10, color: 'var(--hero-text-muted, #c8b89a)' }}
                >
                  ·
                </span>
              )}
            </span>
          );
        })}
      </div>
    </div>
  );
}
